import { render, staticRenderFns } from "./WcDescription.vue?vue&type=template&id=3a6f2e0c&scoped=true"
import script from "./WcDescription.vue?vue&type=script&lang=ts"
export * from "./WcDescription.vue?vue&type=script&lang=ts"
import style0 from "./WcDescription.vue?vue&type=style&index=0&id=3a6f2e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f2e0c",
  null
  
)

export default component.exports